import { v4 as uuidv4 } from 'uuid';

import { UUID } from '../../types';

function generateUuid(): UUID {
  return uuidv4();
}

export default generateUuid;
